webpackJsonp([23899280101116],{

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    top: ", ";\n    transform: translateY(-50%);\n    left: 0;\n    position: fixed;\n    z-index: 8;\n"], ["\n    top: ", ";\n    transform: translateY(-50%);\n    left: 0;\n    position: fixed;\n    z-index: 8;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    width: 160px;\n    @media only screen and (max-width: ", "px) {\n        width: 90px;\n    }\n"], ["\n    width: 160px;\n    @media only screen and (max-width: ", "px) {\n        width: 90px;\n    }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _mwWinner = __webpack_require__(218);
	
	var _mwWinner2 = _interopRequireDefault(_mwWinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.top;
	});
	
	var Img = _styledComponents2.default.img(_templateObject2, function (props) {
	    return props.theme.breakpoints.xlarge;
	});
	
	var MwWinner = function MwWinner(_ref) {
	    var top = _ref.top;
	    return _react2.default.createElement(
	        Container,
	        { top: top },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/news/rla-awarded-marketing-week\u2019s-masters-of-automotive-marketing-2018/" },
	            _react2.default.createElement(Img, {
	                src: _mwWinner2.default,
	                alt: "Marketing Week Masters 2018 Automotive Winner"
	            })
	        )
	    );
	};
	
	exports.default = (0, _styledComponents.withTheme)(MwWinner);
	module.exports = exports["default"];

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    overflow: hidden;\n    height: 100vw;\n    ", ";\n"], ["\n    overflow: hidden;\n    height: 100vw;\n    ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n                  ", ";\n              "], ["\n                  ", ";\n              "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n                  height: 33.33vw;\n              "], ["\n                  height: 33.33vw;\n              "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    opacity: 0;\n    transform: scale(1.2);\n    transition: opacity 0.5s ease, transform 0.25s ease;\n\n    background: ", ";\n\n    &:hover {\n        opacity: 1;\n        transform: scale(1);\n    }\n"], ["\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    opacity: 0;\n    transform: scale(1.2);\n    transition: opacity 0.5s ease, transform 0.25s ease;\n\n    background: ", ";\n\n    &:hover {\n        opacity: 1;\n        transform: scale(1);\n    }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    top: 50%;\n    left: 50%;\n    margin: 0;\n    max-width: 90%;\n    width: 100%;\n    margin-top: 0;\n    position: absolute;\n    transform: translate(-50%, -50%);\n    color: ", ";\n"], ["\n    top: 50%;\n    left: 50%;\n    margin: 0;\n    max-width: 90%;\n    width: 100%;\n    margin-top: 0;\n    position: absolute;\n    transform: translate(-50%, -50%);\n    color: ", ";\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n    font-size: 9vw;\n    font-weight: 800;\n    @media (min-width: ", "px) {\n        font-size: 3vw;\n    }\n"], ["\n    font-size: 9vw;\n    font-weight: 800;\n    @media (min-width: ", "px) {\n        font-size: 3vw;\n    }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n    height: 100%;\n    position: relative;\n    background-image: url('", "');\n    background-size: cover;\n    background-position: ", ";\n    overflow: hidden;\n    transition: transform 0.25s ease;\n    &:hover{\n        transform: scale(1.05);\n    }\n"], ["\n    height: 100%;\n    position: relative;\n    background-image: url('", "');\n    background-size: cover;\n    background-position: ", ";\n    overflow: hidden;\n    transition: transform 0.25s ease;\n    &:hover{\n        transform: scale(1.05);\n    }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n    font-size: 3vw;\n    margin-bottom: 0;\n    font-weight: bold;\n    font-family: Avenir, sans-serif;\n    @media (min-width: ", "px) {\n        font-size: 2vw;\n    }\n    @media (min-width: ", "px) {\n        font-size: 0.9vw;\n    }\n"], ["\n    font-size: 3vw;\n    margin-bottom: 0;\n    font-weight: bold;\n    font-family: Avenir, sans-serif;\n    @media (min-width: ", "px) {\n        font-size: 2vw;\n    }\n    @media (min-width: ", "px) {\n        font-size: 0.9vw;\n    }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _image = __webpack_require__(44);
	
	var _theme = __webpack_require__(6);
	
	var _helpers = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.heightMediaQuery ? (0, _styledComponents.css)(_templateObject2, props.heightMediaQuery) : (0, _styledComponents.css)(_templateObject3);
	});
	
	var Overlay = _styledComponents2.default.div(_templateObject4, function (props) {
	    return (0, _helpers.transparentize)(props.index % 2 ? _theme.colors.accent : _theme.colors.background, 0.52);
	});
	
	var Content = _styledComponents2.default.div(_templateObject5, function (props) {
	    return _theme.colors.white;
	});
	
	var Title = _styledComponents2.default.h3(_templateObject6, _theme.breakpoints.medium);
	
	var Image = _styledComponents2.default.section(_templateObject7, function (props) {
	    return props.backgroundImage;
	}, function (props) {
	    return props.alignment;
	});
	
	var Summary = _styledComponents2.default.p(_templateObject8, _theme.breakpoints.medium, _theme.breakpoints.large);
	
	var WorkSummaryWrapper = function WorkSummaryWrapper(_ref) {
	    var children = _ref.children,
	        slug = _ref.slug,
	        previewType = _ref.previewType;
	
	    switch (previewType) {
	        case "page":
	            return _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: slug },
	                children
	            );
	            break;
	        default:
	            return children;
	    }
	};
	
	var WorkSummary = function WorkSummary(_ref2) {
	    var work = _ref2.work,
	        index = _ref2.index,
	        heightMediaQuery = _ref2.heightMediaQuery;
	
	    return _react2.default.createElement(
	        WorkSummaryWrapper,
	        {
	            slug: work.fields.slug,
	            previewType: work.frontmatter.previewType
	        },
	        _react2.default.createElement(
	            Container,
	            { heightMediaQuery: heightMediaQuery },
	            _react2.default.createElement(
	                Image,
	                {
	                    backgroundImage: (0, _image.getOriginalImageSrc)(work.frontmatter.thumb),
	                    alignment: work.frontmatter.thumbnailAlignment
	                },
	                _react2.default.createElement(
	                    Overlay,
	                    { index: index },
	                    _react2.default.createElement(
	                        Content,
	                        null,
	                        _react2.default.createElement(
	                            Title,
	                            null,
	                            work.frontmatter.title
	                        ),
	                        work.frontmatter.excerpt && _react2.default.createElement(
	                            Summary,
	                            null,
	                            work.frontmatter.excerpt
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = WorkSummary;
	module.exports = exports["default"];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mw-winner.40e1bbcd.png";

/***/ }),

/***/ 1158:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactAnimateOnScroll = __webpack_require__(230);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(221);
	
	var _theme = __webpack_require__(6);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _helpers = __webpack_require__(12);
	
	var _WorkSummary = __webpack_require__(575);
	
	var _WorkSummary2 = _interopRequireDefault(_WorkSummary);
	
	var _HeaderBlock = __webpack_require__(15);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	var _LoadMore = __webpack_require__(461);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	var _MwWinner = __webpack_require__(157);
	
	var _MwWinner2 = _interopRequireDefault(_MwWinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var lastarrayIndex = null;
	
	var rowsAdvance = 3;
	
	var heightMediaQuery = "\n@media (min-width: " + _theme.breakpoints.medium + "px) {\n    height: 50vw;\n}\n    @media (min-width: " + _theme.breakpoints.large + "px) {\n        height: 33.33vw;\n    }\n";
	
	var PeoplePage = function (_React$Component) {
	    _inherits(PeoplePage, _React$Component);
	
	    function PeoplePage(props) {
	        _classCallCheck(this, PeoplePage);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    PeoplePage.prototype.componentDidMount = function componentDidMount() {
	        var work = this.props.data.allMarkdownRemark.edges;
	
	        // const chunks = randomChunkArray(shuffleArray(work), 2, 3);
	
	        var chunks = (0, _helpers.randomChunkArray)(work, 2, 3);
	
	        var layouts = {
	            0: [[]],
	            1: [[12]],
	            2: [[5, 7], [6, 6], [7, 5]],
	            3: [[3, 6, 3], [4, 4, 4]]
	        };
	        var layout = this.generateLayout(chunks, layouts);
	
	        this.setState({
	            rows: rowsAdvance,
	            chunkedWork: chunks,
	            layout: layout
	        });
	    };
	
	    PeoplePage.prototype.handleClick = function handleClick() {
	        this.setState({
	            rows: this.state.rows + rowsAdvance
	        });
	    };
	
	    PeoplePage.prototype.generateLayout = function generateLayout(chunks, layouts) {
	        var result = new Array();
	
	        chunks.map(function (chunk, i) {
	            var layoutArray = layouts[chunk.length];
	            var getArrayIndex = function getArrayIndex() {
	                return (0, _helpers.random)(0, layoutArray.length - 1);
	            };
	            var arrayIndex = 0;
	
	            // make sure that there are no duplicate rows if possible
	            if (layoutArray.length > 1) {
	                arrayIndex = getArrayIndex();
	                while (arrayIndex == lastarrayIndex) {
	                    arrayIndex = getArrayIndex();
	                }
	                lastarrayIndex = arrayIndex;
	            }
	
	            result.push(layoutArray[arrayIndex]);
	        });
	
	        return result;
	    };
	
	    PeoplePage.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            work = _props.data.allMarkdownRemark.edges,
	            transition = _props.transition;
	        var _state = this.state,
	            chunkedWork = _state.chunkedWork,
	            rows = _state.rows,
	            layout = _state.layout;
	
	
	        return _react2.default.createElement(
	            "div",
	            { style: transition && transition.style },
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                { title: "Work | RLA Group | Full Service Advertising Agency" },
	                _react2.default.createElement("meta", {
	                    name: "title",
	                    content: "Work | RLA Group | Full Service Advertising Agency"
	                })
	            ),
	            _react2.default.createElement(_MwWinner2.default, { top: "35%" }),
	            _react2.default.createElement(
	                _rlaComponents.Row,
	                null,
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    null,
	                    _react2.default.createElement(
	                        _HeaderBlock2.default,
	                        {
	                            fontSize: _theme2.default.pageHeaderSection.fontSize,
	                            padding: _theme2.default.pageHeaderSection.padding },
	                        "Our ",
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "Work"
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    _rlaComponents.Row,
	                    { expanded: true, collapse: true },
	                    chunkedWork && chunkedWork.slice(0, rows).map(function (chunk, i) {
	                        return chunk.map(function (_ref, index) {
	                            var caseStudy = _ref.node;
	
	                            return _react2.default.createElement(
	                                _rlaComponents.Column,
	                                {
	                                    medium: 6,
	                                    large: layout[i][index],
	                                    key: index,
	                                    collapse: true },
	                                _react2.default.createElement(
	                                    _reactAnimateOnScroll2.default,
	                                    {
	                                        animateIn: "fadeIn",
	                                        delay: 250 * index,
	                                        animateOnce: true },
	                                    _react2.default.createElement(_WorkSummary2.default, {
	                                        heightMediaQuery: heightMediaQuery,
	                                        work: caseStudy,
	                                        index: index
	                                    })
	                                )
	                            );
	                        });
	                    })
	                )
	            ),
	            chunkedWork && chunkedWork.length > rows && _react2.default.createElement(
	                _LoadMore2.default,
	                { onClick: function onClick() {
	                        return _this2.handleClick();
	                    } },
	                "Load More"
	            )
	        );
	    };
	
	    return PeoplePage;
	}(_react2.default.Component);
	
	exports.default = PeoplePage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-work-js-c97da0bd2345c0426483.js